// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"281bfd40","459":"91a5240d","691":"b94943ee","785":"da4b6d37","810":"2dc5133e"}[chunkId] + ".chunk.js";
};